import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { EmptyInfos } from '../../models/empty-infos.model';

@Component({
    selector: 'web-empty-state',
    templateUrl: './empty-state.component.html',
    styleUrls: ['./empty-state.component.scss'],
    imports: [CommonModule],
})
export class EmptyStateComponent {
    @Input() emptyInfos: EmptyInfos = {
        title: '',
        text: '',
        img: '',
        imgMargin: '0',
        buttonLabel: '',
        circledGreen: false,
        iconSize: 10,
        smallGap: false,
        titleWidth: '100%',
    };
}
